import { render, staticRenderFns } from "./GroupChatList.vue?vue&type=template&id=a1533678&scoped=true"
import script from "./GroupChatList.vue?vue&type=script&lang=js"
export * from "./GroupChatList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1533678",
  null
  
)

export default component.exports